/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionStatsSchema } from './collection-stats-schema';
import { dailyReportSchema } from './daily-report-schema';
import { hardestChallengeSchema } from './hardest-challenge-schema';
import { levelStatsSchema } from './level-stats-schema';
import { overallSchema } from './overall-schema';
import { streakSchema } from './streak-schema';
import { upcomingSchema } from './upcoming-schema';

export const getDashboardResponseDataSchema = z.object({
  score: z.number().int(),
  nickname: z.string(),
  rank: z.number().int().nullable().optional(),
  upcoming: upcomingSchema.optional(),
  streak: streakSchema,
  overall: overallSchema,
  levels: z.record(z.string(), levelStatsSchema),
  dailyProgress: z.record(z.string(), dailyReportSchema),
  practiceHours: z.record(z.string(), z.number()),
  hardestChallenges: z.array(hardestChallengeSchema),
  collections: z.array(collectionStatsSchema),
});

export type IGetDashboardResponseData = z.infer<typeof getDashboardResponseDataSchema>;

export const getDashboardResponseSchema = createApiResponseSchema(
  getDashboardResponseDataSchema,
) as z.ZodSchema<IAPI<IGetDashboardResponseData>>;

export type IGetDashboardResponse = IAPI<IGetDashboardResponseData>;
